import { render, staticRenderFns } from "./GradientBackground.vue?vue&type=template&id=5a456f04&scoped=true&"
import script from "./GradientBackground.vue?vue&type=script&lang=js&"
export * from "./GradientBackground.vue?vue&type=script&lang=js&"
import style0 from "./GradientBackground.vue?vue&type=style&index=0&id=5a456f04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a456f04",
  null
  
)

export default component.exports